export const USER_ROLE = {
  USER: 0,
  MANAGER: 1,
};
